import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import {
    FetchRequestOptions,
    fetchService,
    CORS_MODE_NAME,
    GET_METHOD_NAME,
} from 'owa-data-provider-info-fetcher';
import { format } from 'owa-string-utils';
import { parse as parseUrl, Url } from 'url';
import { getEncodedUrlForVroom } from 'owa-data-provider-info-fetcher';
import { API_BASE_FOR_SHARES } from 'owa-fileprovider-services';
import { GetSharingInfoResponseBase } from './GetSharingInfoResponseBase';
import { trace } from 'owa-trace';

const getFileInfoRequestUrlFormat: string =
    'https://{0}/{1}/{2}/?expand=sharepointIds,permission,driveItem(select=webDavUrl,name,folder,package)';

export async function getODBFileInfo(url: string): Promise<GetSharingInfoResponseBase> {
    const parsedUrl: Url = parseUrl(url);
    const requestUrl: string = format(
        getFileInfoRequestUrlFormat,
        parsedUrl.hostname,
        API_BASE_FOR_SHARES,
        getEncodedUrlForVroom(url)
    );
    const requestOptions: FetchRequestOptions = {
        method: GET_METHOD_NAME,
        mode: CORS_MODE_NAME,
        body: null,
        datapointNamePrefix: 'GetODBFileInfo',
    };

    const responseText: string = await fetchService(
        AttachmentDataProviderType.OneDrivePro,
        requestUrl,
        null,
        requestOptions,
        null
    );
    trace.info(responseText);

    // VSTO: 60903 Move ODB GetSharingInfo to client
    return null;
}
